'use strict';
import { load } from 'recaptcha-v3'

angular.module('cgmemApp')
  .controller('SignupCtrl', function ($state, $http, AppConfig) {

    this.loading = true;
    AppConfig.get()
      .then(appConfig => {
        this.appConfig = appConfig;
        this.account = {address: {}};
        this.member = {gender:'F', emailLists: []};
        this.emailLists = {};

        this.appConfig.mailingLists.forEach(l => {
          if(!l.private) {
            this.emailLists[l.code] = {
              description: l.description,
              selected: (l.code == 'club')
            }
          }
        });

      })
      .finally( () => this.loading = false);

    this.register = () => {
      this.loading = true;
      Object.entries(this.emailLists).forEach( ([k, v]) => {
        if(v.selected)
          this.member.emailLists.push(k);
      });

      load(this.appConfig.selfSignup.recaptchaKey)
        .then(recaptcha => recaptcha.execute('submit'))
        .then(token => $http.post('/api/signup', {account: this.account, member: this.member, token}))
        .then(r => $state.go('signupSuccess'))
        .catch(err => $state.go('signupFail', {status: (err && err.status)}))
        .finally( () => {
          this.loading = false;
        });
    }
  })
  .controller('SignupFailCtrl', function ($stateParams) {
    this.status = $stateParams.status;
  })
  .controller('SignupSuccessCtrl', function (AppConfig) {
    this.loading = true;
    AppConfig.get()
      .then(appConfig => {
        this.appConfig = appConfig;
        this.loading = false;
      });
  });
